import moment from 'moment';
import { dropStatusDocumento, dropSituacaoRemessa } from 'utils/drops';

const getExposicaoFeiraFilterFields = (drops = {}) => [
  {
    name: 'id',
    label: 'ID',
    type: 'number',
  },
  {
    name: 'status',
    label: 'Status',
    type: 'select',
    options: dropStatusDocumento,
    multiple: true,
  },
  {
    name: 'situacao',
    label: 'Situação',
    type: 'select',
    options: dropSituacaoRemessa,
    multiple: true,
  },
  {
    name: 'natureza_operacao_id',
    label: 'Natureza da Operação',
    type: 'select',
    options: drops?.NaturezaOperacao?.filter((f) => f?.terceiro === 'SIM'),
    multiple: true,
  },
  {
    name: 'dtemissao.i',
    column: 'dtemissao',
    label: 'Data de Emissão Inicial',
    type: 'date',
    defaultValue: moment().subtract(1, 'months').format('YYYY-MM-DD'),
  },
  {
    name: 'dtemissao.f',
    column: 'dtemissao',
    label: 'Emissão Final',
    type: 'date',
  },
  {
    name: 'documento',
    label: 'Nº do Documento',
    type: 'number',
    initial: true,
  },
  {
    name: 'entidade',
    label: 'Entidade',
    type: 'virtual-select',
    options: drops?.Entidade,
    multiple: true,
  },
  {
    name: 'vldocto',
    label: 'Valor',
    type: 'currency',
  },
];

export default getExposicaoFeiraFilterFields;
